<app-layout>
  <div class="half-price">
    <div class="half-price__section">
      <div class="half-price__header">
        <div class="half-price__title">
          <p class="h1">Meia entrada</p>
        </div>
        <div class="half-price__subtitle">
          <p>Você pode ter direito à meia entrada.</p>
        </div>
      </div>
    </div>

    <div class="half-price__text">
      <div class="container">
        <p>
          A compra de meia entrada e/ou outros descontos estará sujeita às regras dos produtores/organizadores de cada
          evento. Consulte a página oficial do referido espetáculo. A Yes7 Tickets não se responsabiliza pelo
          cumprimento de tais políticas por parte dos realizadores, mas te auxilia a entender e buscar seu direito, em
          caso de dúvidas entre em contato com nosso suporte!
        </p>

        <h3>PARA ESTUDANTES:</h3>

        <p>
          De acordo com a lei federal no12.933, para ter acesso ao benefício da meia entrada você deve apresentar a CIE
          – Carteira de Identificação Estudantil, que deve conter:
        </p>
        <p>
          Nome completo e data de nascimento;Foto;<br />
          Grau de escolaridade e nome da instituição de ensino na qual o estudante esteja matriculado;<br />
          Data de validade até o dia 31 de março do ano subsequente ao de sua expedição;<br />
          Certificação digital.<br />
          Não serão aceitos boletos bancários, declaração de matrícula e carteirinhas fora do padrão acima.
        </p>
        <p>*A comprovação da meia entrada deverá ser apresentada no ato da compra e no dia do evento.</p>

        <h3>QUEM MAIS TEM DIREITO?</h3>

        <p>Também farão jus ao benefício da meia-entrada:</p>
        <p>
          As pessoas com deficiência, inclusive seu acompanhante quando necessário, sendo que este terá idêntico
          benefício no evento em que comprove estar nesta condição, na forma do regulamento.<br />
          Jovens de 15 a 29 anos de idade de baixa renda, inscritos no Cadastro Único para Programas Sociais do Governo
          Federal (CadÚnico) e cuja renda familiar mensal seja de até 2 (dois) salários mínimos, na forma do
          regulamento.<br />
          IDOSOS: De acordo com a Lei Federal no. 10741/2003, mais conhecida como Estatuto do Idoso, as pessoas com
          idade igual ou superior a 60 anos têm direito à meia-entrada para eventos artísticos e de lazer. Para
          comprovação do benefício é necessária a apresentação do RG ou documento com foto e data de nascimento na
          entrada do evento. Atenção: É obrigatória, na entrada, a apresentação da documentação que comprove o direito
          ao beneficio de acordo com a legislação em vigor. A Yes7 Tickets não se responsabiliza pela entrada no evento,
          caso não ocorra a comprovação ou o não reconhecimento do documento de meia-entrada o cliente não poderá entrar
          no evento.A Yes7 Tickets não se responsabiliza pelos Realizadores de eventos que, eventualmente, não cumprirem
          as regras de meia entrada.
        </p>

        <p>
          *Sempre sujeito a disponibilidade da cota de 40% da meia-entrada sobre o total de ingressos disponível para o
          evento.
        </p>

        <p>** É obrigatória a apresentação do documento no momento da entrada do evento.</p>

        <p>
          *** A meia entrada não se aplica sobre promoções e não se aplica para todos os setores, isto é, não será
          cumulativa com quaisquer outras promoções e convênios e, também, não se aplica ao valor dos serviços
          adicionais eventualmente oferecidos em camarotes, áreas e cadeiras especiais.
        </p>
      </div>
    </div>
  </div>
</app-layout>
